<template>
    <div>
        <el-dialog :visible.sync="successfulUpdateModal" v-if="dataUpdate" :center="true" :width="widthModal()" class="dialog-mobile"
                   :close-on-click-modal="!isOnRedeem || dataUpdated"  :close-on-press-escape="!isOnRedeem || dataUpdated" @close="handleModalClose">
            <div class="content-update">
                <div class="form-survey mt-4">
                    <h5 class="text-title-bat">{{ dataUpdate.name ? dataUpdate.name : 'Actualización de datos' }}</h5>
                    <h6 class="text-bat">{{ dataUpdate.description ? dataUpdate.description : 'Para mejorar tu experiencia y cumplir con nuestras políticas de seguridad, te invitamos a actualizar tus datos. ¡Solo te tomará un momento!' }}</h6>
                    <div class="container pt-4">
                        <form @submit.prevent="submitForm" class="row g-3">
                            <div class="col-12 col-md-6 my-3">
                                <div class="d-flex flex-column">
                                    <label :class="labelClassesEmail"
                                           :style="{ color: focusStates.email && !errorEmail ? '#204F9A' : errorEmail ? '#ff0000' : 'inherit' }"
                                           for="email" style="width:60%;">Correo
                                        electrónico*</label>
                                    <input v-model="email" type="text" name="email" class="input-custom border"
                                           :class="{ 'text-blue': focusStates.email && !errorEmail, 'text-red': errorEmail, 'border-red': errorEmail }"
                                           @focus="handleFocus('email')" @blur="handleBlur('email');" autocomplete="off">
                                    <p v-if="errorEmail" class="text-red">{{ messageErrorEmail }}</p>
                                </div>
                            </div>

                            <div class="col-12 col-md-6 my-3">
                                <div class="d-flex flex-column">
                                    <label :class="labelClassesMobile"
                                           :style="{ color: focusStates.mobile_number && !errorMobile ? '#204F9A' : errorMobile ? '#ff0000' : 'inherit' }"
                                           for="mobile_number" style="width:26%">Celular*</label>
                                    <input v-model="mobile_number" type="text" name="mobile_number"
                                           class="input-custom border"
                                           :class="{ 'text-blue': focusStates.mobile_number && !errorMobile, 'text-red': errorMobile, 'border-red': errorMobile }"
                                           @focus="handleFocus('mobile_number')" @blur="handleBlur('mobile_number')"
                                           @input="validateMobileNumber" autocomplete="off">
                                    <p v-if="errorMobile" class="text-red">{{ messageErrorMobile }}</p>
                                </div>
                            </div>

                            <div>
                                <div class="row px-3">
                                    <div class="col-md-12 mb-3 d-flex">
                                        <input type="checkbox" v-model="isAdult" class="mt-1" @change="handleAdultChange">
                                        <span class="ps-1">Confirmo que soy mayor de 18 años</span>
                                    </div>
                                    <div class="col-md-12 mb-3 d-flex">
                                        <input type="checkbox" v-model="acceptDataPolicy" class="mt-1" @change="handlePolicyChange">
                                        <span class="ps-1">Acepto la
                                            <a :href="dataPolicyUrl" target="_blank" rel="noopener noreferrer">política de tratamiento de datos y términos y condiciones</a>
                                        </span>
                                    </div>
                                    <p v-if="errorAdult" class="text-red">Debes confirmar que eres mayor de 18 años.</p>
                                    <p v-if="errorPolicy" class="text-red">Para continuar, debes aceptar la política de
                                        tratamiento de datos.</p>
                                </div>
                            </div>

                            <div class="d-flex justify-content-center boton">
                                <button class="w-full w-100 p-3 btn-popups text-title-bat"
                                    :style="(isSubmitting || !pageIsLoaded) ? {
                                        backgroundColor: '#cccccc',
                                        color: '#666666',
                                        cursor: 'not-allowed',
                                        opacity: '0.7'
                                    } : {}"
                                    type="submit"
                                    :disabled="isSubmitting || !pageIsLoaded">Aceptar</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="modalOtp" v-if="modalOtp" :width="widthModal()" center :close-on-click-modal="false"
                   :close-on-press-escape="false">
            <h6 class="text-title-bat text-center">Código de confirmación</h6>
            <div class="modal-otp-change-password mt-3">
                <h6 class="text-bat mb-4 text-center">
                    A tu número de celular <strong>{{ hiddenDigits() }}</strong>
                    registrado con nosotros, se enviará un
                    <strong>código</strong> de 4 dígitos, el cual es necesario para la actualización de datos.
                </h6>
            </div>
            <div class="modal-otp-change-password">
                <div class="row">
                    <div class="col-12">
                        <div class="modal-otp-change-password">
                            <input ref="input1" v-model="inputs[0]" @input="onInput(0)" type="text" min="0" max="9"
                                   class="otp-input-change-password">
                            <input ref="input2" v-model="inputs[1]" @input="onInput(1)" type="text" min="0" max="9"
                                   class="otp-input-change-password">
                            <input ref="input3" v-model="inputs[2]" @input="onInput(2)" type="text" min="0" max="9"
                                   class="otp-input-change-password">
                            <input ref="input4" v-model="inputs[3]" @input="onInput(3)" type="text" min="0" max="9"
                                   class="otp-input-change-password">
                        </div>
                        <p v-if="messageOtp !== ''" class="text-danger text-center">{{ messageOtp }}</p>
                    </div>
                </div>
            </div>
            <div class="modal-otp-change-password">
                <p class="text-bat text-center">Falta {{ tiempoFormateado() }} para poder reenviar el código nuevamente,
                    haga clic
                    <el-link v-if="tiempo !== 0" type="info" disabled
                             style="font-size: 12px; text-decoration: underline;">"Aquí"</el-link>
                    <el-link v-else type="primary" class="otp-link" style="font-size: 12px"
                             @click="submitForm">"Aquí"</el-link>
                </p>
            </div>
            <template #footer>
                <div class="dialog-footer mb-3 d-flex flex-column-reverse">
                    <div>
                        <a type="button" class="w-50 fs-6 mt-4 border-2 text-btn-outstanding"
                           @click="closeProcess()">Regresar</a>
                    </div>
                    <div>
                        <button class="w-50 mx-1 btn btnBlue text-title-bat rounded-3" :disabled="tiempo === 0"
                                @click="validateOtp()">
                            Enviar
                        </button>
                    </div>
                </div>
            </template>
        </el-dialog>

        <el-dialog :visible.sync="modalofSucesss" :center="true" :width="widthModal()"
                   style="width: 75% !important; z-index: 2001; margin: 147px auto 50px !important;" class="dialog-mobile">
            <div class="d-flex flex-column justify-content-center align-items-center text-center mt-4"
                 style="word-break: normal">
                <img class="img-victoria-tour mb-2" src="/img/victoria-tour.png" alt="victoria-tour">
                <div>
                    <h5 class="text-title-bat">
                        ¡Perfecto!
                    </h5>
                </div>
                <div>
                    <h6 class="text-bat">
                        Hemos recibido tus datos y están en proceso de validación.
                        <strong>¡Te avisaremos pronto cuando todo esté listo!</strong>
                    </h6>
                </div>
                <div class="col-12">
                    <span slot="footer" class="dialog-footer">
                        <el-button type="primary" class="w-full w-100 p-3 btnBlue mt-3 text-title-bat mt-4"
                                   @click="modalofSucesss = false">Aceptar</el-button>
                    </span>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            email: '',
            mobile_number: '',
            successfulUpdateModal: false,
            modalofSucesss: false,
            focusStates: {
                email: false,
                mobile_number: false
            },
            errorEmail: false,
            messageErrorEmail: '',
            errorMobile: false,
            messageErrorMobile: '',
            isAdult: false,
            acceptDataPolicy: false,
            errorAdult: false,
            errorPolicy: false,
            isInputFocused: false,
            dataPolicyUrl: '/tratamiento-datos',
            modalOtp: false,
            inputs: ['', '', '', ''],
            tiempoInicial: 120,
            tiempo: 120,
            contadorIniciado: false,
            messageOtp: '',
            modalErrorOtp: false,
            success: false,
            messageSuccess: null,
            messageShown: false,

            dataUpdate: '',
            dataUpdated: false,
            isProcessing: false,
            isSubmitting: false,
            modalClosedByUser: false,

            pageIsLoaded: false,
        }
    },
    mounted() {
        this.getPopup()

        if (document.readyState === 'complete') {
            this.pageIsLoaded = true;
        } else {
            window.addEventListener('load', () => {
                this.pageIsLoaded = true;
            });
        }
    },
    computed: {
        labelClassesEmail() {
            return {
                'text-blue': this.focusStates.email && !this.errorEmail,
                'text-red': this.errorEmail,
            };
        },
        labelClassesMobile() {
            return {
                'text-blue': this.focusStates.mobile_number && !this.errorMobile,
                'text-red': this.errorMobile,
            };
        },
        isOnRedeem() {
            return window.location.pathname === '/show-shopping-cart';
        },
    },
    watch: {
        email(newEmail) {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (emailPattern.test(newEmail)) {
                this.errorEmail = false;
                this.messageErrorEmail = '';
            }
        }
    },
    methods: {
        widthModal() {
            let width = '90%';
            if (this.$mq === 'md') width = '60%';
            else if (this.$mq === 'lg') width = '50%';
            else if (this.$mq === 'xl') width = '30%';
            return width;
        },
        handleFocus(field) {
            this.$set(this.focusStates, field, true);
        },
        handleBlur(field) {
            this.$set(this.focusStates, field, false);
        },
        validateMobileNumber() {
            if (this.mobile_number.length !== 10) {
                this.errorMobile = true;
                this.messageErrorMobile = 'Por favor, ingresa un número móvil válido.';
            } else if (this.mobile_number.startsWith('3') && this.mobile_number.length === 10) {
                this.errorMobile = false;
                this.messageErrorMobile = '';
            } else {
                this.errorMobile = true;
                this.messageErrorMobile = 'El número debe comenzar con 3.';
            }
        },
        submitForm() {
            if (this.isSubmitting) return;  // Evitar clics múltiples

            this.errorEmail = false;
            this.errorMobile = false;
            this.errorAdult = false;
            this.errorPolicy = false;
            this.isSubmitting = true;  // Activar el bloqueo de clics

            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (this.email.length === 0 || !emailPattern.test(this.email)) {
                this.errorEmail = true;
                this.messageErrorEmail = 'Ingresa un correo electrónico válido.';
            }

            this.validateMobileNumber()

            if (!this.isAdult) {
                this.errorAdult = true;
            }

            if (!this.acceptDataPolicy) {
                this.errorPolicy = true;
            }

            if (!this.errorEmail && !this.errorMobile && !this.errorAdult && !this.errorPolicy) {
                this.modalClosedByUser = false;
                this.generateOtp();
            }

            this.isSubmitting = false;
        },
        getDataUpdatePopup() {
            this.loading++
            axios.get(`/get-data-update`)
                .then(({ data }) => {
                    this.mobile_number = data.mobile_number == null ? '':data.mobile_number
                    this.email = data.email == null ? '':data.email
                    // this.showDataUpdatePopup = true
                    this.loading--
                })
        },

        getPopup() {
            this.loading++
            axios.get(`/get-popup-update-data`)
                .then(({ data }) => {
                    this.dataUpdate = data.update_data_popup

                    this.successfulUpdateModal = this.dataUpdate !== null;

                    if (this.successfulUpdateModal) {
                        this.email = data.email;
                        this.mobile_number = data.mobile_number;
                        this.getDataUpdatePopup();
                    }
                })
                .finally(() => {
                    this.loading--;
                });
        },

        hiddenDigits() {
            if (this.mobile_number.length < 4) {
                return this.mobile_number;
            }

            let lastFourDigits = this.mobile_number.slice(-4);
            let hiddenDigits = '*'.repeat(this.mobile_number.length - 4);
            return hiddenDigits + lastFourDigits;
        },

        generateOtp() {
            const payload = {
                email: this.email,
                mobile_number: this.mobile_number
            };
            axios.post(`/generate-otp-update-data`, payload)
                .then(response => {
                    if (response.data.status === 'success') {
                        this.successfulUpdateModal = false;
                        this.dataUpdated = true;
                        this.modalOtp = true;
                        this.iniciarContador();
                    } else {
                        this.error = true;
                        this.messageError = 'Error al generar otp, por favor comunicarse con soporte.';
                    }
                })
                .catch(e => {
                    console.error("Error al generar OTP:", e);
                })
        },
        validateOtp() {
            const isValid = this.inputs.every(value => value.trim() !== '');
            if(!isValid){
                let message = 'El código ingresado no es correcto. Por favor, inténtalo de nuevo';
                this.inputs = ['', '', '', ''];
                this.messageOtp = message;
            }
            const cod = parseInt(this.inputs.join(''));

            axios.post(`/validate-otp-update-data`, { 'cod': cod })
                .then(response => {
                    if (response.data.validate.status) {
                        this.modalOtp = false;
                        this.loading++;
                        this.success = true;
                        this.messageSuccess = 'Token aprovado, para realizar el proceso de cambio de contraseña.';

                        const payload = {
                            email: this.email,
                            mobile_number: this.mobile_number
                        };

                        this.saveData(payload);
                    } else {
                        let message = 'El código ya expiro, por favor vuelva a intentar el proceso de nuevo.';
                        this.inputs = ['', '', '', ''];
                        if (response.data.validate.message === 'OTP does not exist' || response.data.validate.message === 'OTP is not valid') {
                            message = 'El código ingresado no es válido. Por favor, inténtalo de nuevo';
                        }
                        this.messageOtp = message;
                    }
                })
                .catch(e => {
                    //
                })
        },
        iniciarContador() {
            if (this.contadorIntervalo !== null) {
                clearInterval(this.contadorIntervalo);
            }
            this.contadorIniciado = true;
            this.tiempo = this.tiempoInicial;
            this.contadorIntervalo = setInterval(() => {
                if (this.tiempo > 0) {
                    this.tiempo--;
                }
            }, 1000);
        },
        tiempoFormateado() {
            const minutos = Math.floor(this.tiempo / 60);
            const segundos = this.tiempo % 60;
            return `${String(minutos).padStart(2, '0')}:${String(segundos).padStart(2, '0')}`;
        },
        onInput(index) {
            if (!isNaN(this.inputs[index]) && this.inputs[index] >= 0 && this.inputs[index] <= 9) {
                if (index < this.inputs.length - 1) {
                    this.$refs['input' + (index + 2)].focus();
                }
            } else {
                this.inputs[index] = '';
            }
        },
        closeProcess() {
            this.modalOtp = false;
            this.error = true;
            this.messageError = 'Proceso de cambio de contraseña cerrado.';
            this.successfulUpdateModal = true;
        },

        saveData(payload) {
            axios.post(`/store-update-data`, payload)
                .then(response => {
                    if (response.data.status === 'success') {
                        this.modalofSucesss = true
                        this.dataUpdated = true;

                        if (!(this.isOnRedeem)) {
                            this.successfulUpdateModal = false;
                        }
                    } else {
                        this.error = true;
                        this.messageError = 'Error al actualizar sus datos';
                    }
                })
                .catch(e => {
                    //
                })
        },

        checkModalClose() {
            if (this.isProcessing) return;
            this.isProcessing = true;

            if (this.isOnRedeem && !this.dataUpdated) {
                if (!this.messageShown) {
                    this.$message.warning('Debes actualizar tus datos antes de cerrar el pop-up');
                    this.messageShown = true;

                    setTimeout(() => {
                        this.messageShown = false;
                    }, 3000);
                }

                this.successfulUpdateModal = true;
            } else {
                if (this.modalClosedByUser) {
                    if (this.dataUpdate && this.dataUpdate.required === 1 && !this.dataUpdated) {
                        this.logout();
                        this.resetState();
                    } else {
                        this.successfulUpdateModal = false;
                    }
                } else {
                    this.successfulUpdateModal = false;
                }
            }

            this.isProcessing = false;
        },
        resetState() {
            this.isProcessing = false;
        },

        logout() {
            axios.post('/logout', {})
                .then(({data}) => {
                    window.location.href = "/login";
                })
                .catch(error => {
                    console.error('Error al cerrar sesión:', error);
                    this.$message.error('Error al cerrar sesión, por favor intente nuevamente.');
                });
        },
        handleModalClose() {
            this.modalClosedByUser = true;
            this.checkModalClose();
        },
        handleAdultChange() {
            if (this.isAdult) {
                this.errorAdult = false;
                this.messageErrorAdult = '';
            }
        },
        handlePolicyChange() {
            if (this.acceptDataPolicy) {
                this.errorPolicy = false;
                this.messageErrorPolicy = '';
            }
        }

    },
}
</script>
